<div class="relative w-full -mt-[200px] z-[1] pb-20 md:pb-24">
  <div class="max-w-[1200px] mx-auto px-6">
    <div class="bg-white rounded-[20px] shadow-[0_8px_30px_rgba(0,0,0,0.08)] p-12 md:p-16">
      <div class="flex flex-col items-center justify-center py-12 text-center">
        <icon [name]="iconName()" class="error-icon-large text-red-500 mb-6"></icon>
        <h2 class="text-3xl font-semibold text-gray-900 mb-4">{{ title() }}</h2>
        @if (message()) {
          <p class="text-lg text-gray-600 mb-8">{{ message() }}</p>
        }
        <button class="white-icon inline-flex items-center gap-2 px-6 py-3 bg-[#0071e3] text-white rounded-full font-medium hover:bg-[#0077ed] transition-all duration-200" 
                (click)="onButtonClick()">
          <icon name="navigate_next" class="inline-flex items-center" style="transform: rotate(180deg);"></icon>
          <span>{{ buttonText() }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
